module.exports = __webpack_public_path__ + "img/hover-imgs-item-2.2beac7cf.png";